
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftLeft50 as ObiThreewayAnalogInleftLeft50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-left-50.js';
 
 
 

 
 export const ObiThreewayAnalogInleftLeft50 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-left-50',
   elementClass: ObiThreewayAnalogInleftLeft50Element,
   events: {
     
   }
  });
 
 